<div class="text-align-center ph-6 pb-6">
  <sb-stamp class="pt-8 mh-auto" [type]="'dimmed-red'">
    <sb-icon [name]="'alert-circle'" [size]="'3'" />
  </sb-stamp>

  <h3 class="mt-4 t-5@r color-void">Your Balance is Negative</h3>
  <div class="mt-3@r t-8@r color-ash">
    Your balance is {{ balance() }}. To continue, please contact customer support to resolve this issue. Until then, you
    will not be able to make new purchases.
  </div>
  <button
    class="mt-6 width-full"
    sbButton
    [routerLink]="['/next/contact']"
    [size]="'big'"
    [variant]="'fill-jet'"
    (click)="confirm()"
  >
    Contact support
  </button>
</div>
